import LazyLoadImg from "components/LazyLoadImg";
import { AssetTypes } from "constant/AssetTypes";
import { HiArrowRight } from "react-icons/hi";
import { Link } from "react-router-dom";

function GridCard({ theme, title, info, img, link }: any) {
  const enabled = localStorage.getItem("ppv_enabled");
  const isLight = theme === "light";
  const textColor = isLight ? "text-black" : "text-white";

  const exploreLink = (
    <Link
      to={link}
      className={`group/explore inline-flex items-center font-medium ${textColor}`}
    >
      Explore
      <HiArrowRight className="ml-2 transition-transform duration-200 group-hover/explore:translate-x-1" />
    </Link>
  );

  return (
    <>
      {/* hover draw-border (square corners, no radius) */}
      <style>{`
        .grid-card {
          position: relative;
        }
        .grid-card::before,
        .grid-card::after {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          pointer-events: none;
          z-index: 5;
        }
        .grid-card::before {
          top: 0;
          left: 0;
          border-top: 2px solid var(--red, #f30543);
          border-left: 2px solid var(--red, #f30543);
          transition: height 0.25s ease, width 0.25s ease 0.25s;
        }
        .grid-card::after {
          bottom: 0;
          right: 0;
          border-bottom: 2px solid var(--red, #f30543);
          border-right: 2px solid var(--red, #f30543);
          transition: height 0.25s ease, width 0.25s ease 0.25s;
        }
        .grid-card:hover::before,
        .grid-card:hover::after {
          width: 100%;
          height: 100%;
          transition: width 0.85s ease, height 0.85s ease 0.85s;
        }
      `}</style>

      <div
        className={`grid-card !overflow-hidden pt-4 ${
          isLight ? "button-white gridCard-hover" : "background-gray gridCard-hover"
        }`}
      >
        <div className="mx-auto w-[90%] overflow-hidden">
          <div className="w-[65%] max-sm:w-full">
            <h2 className={`mb-4 ${textColor}`}>
              <span className="red-text mr-2 font-extrabold sm:text-md md:text-lg lg:text-xl">
                AYOZAT
              </span>{" "}
              {title === AssetTypes.PayPerView ? "Pay-Per-View" : <>{title}</>}
            </h2>
            <p className={`mb-4 font-medium leading-relaxed ${textColor}`}>
              {info}
            </p>

            {title === AssetTypes.PayPerView ? (
              enabled === "1" ? (
                exploreLink
              ) : (
                <p className={`flex items-center font-medium ${textColor}`}>
                  Coming soon
                </p>
              )
            ) : (
              exploreLink
            )}
          </div>

          {/* bottom image */}
          <div className="-mb-[7px] w-full overflow-hidden">
            <img
              src={img}
              alt="card figure"
              className="img-shadow mt-8 w-full overflow-hidden shadow-2xl"
              style={{
                backgroundSize: "100%",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default GridCard;